import React from 'react';
import { faTags } from '@fortawesome/pro-solid-svg-icons/faTags';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TagsSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTags} {...props} />;
}
